// @ts-nocheck
import { useRef, useState } from 'react';
import { Button, Intent } from '@blueprintjs/core';
import clsx from 'classnames';
import { Box, Group, Icon, Stack } from '@/components';
import { Dropzone, DropzoneProps } from '@/components/Dropzone';
import { MIME_TYPES } from '@/components/Dropzone/mine-types';
import { useUncontrolled } from '@/hooks/useUncontrolled';
import styles from './ImportDropzone.module.css';
import logo from './upload.png'

export interface ImportDropzoneFieldProps {
  initialValue?: File;
  value?: File;
  onChange?: (file: File) => void;
  dropzoneProps?: DropzoneProps;
  uploadIcon?: JSX.Element;
  title?: string;
  subtitle?: string;
  classNames?: Record<string, string>;
  hintText?: React.ReactNode;
}

export function ImportDropzoneField({
  initialValue,
  value,
  onChange,
  dropzoneProps,
  uploadIcon = <img src={logo} alt="upload" />,
  title = 'Drag images here or click to select files',
  subtitle = 'Drag and Drop file here or Choose file',
  classNames,
  hintText,
}: ImportDropzoneFieldProps) {
  const [localValue, handleChange] = useUncontrolled({
    value,
    initialValue,
    finalValue: null,
    onChange,
  });
  const openRef = useRef<() => void>(null);
  const [dropError, setDropError] = useState<string | null>(null);

  const handleRemove = () => {
    handleChange(null);
  };

  return (
    <Dropzone
      onDrop={(files) => {
        setDropError(null);
        handleChange(files[0]);
      }}
      onReject={(files) => {
        const error = files[0]?.errors?.[0];
        let message = 'File rejected.';

        if (error?.code === 'file-too-large') {
          message = 'File must be under 150KB.';
        } else if (error?.message) {
          message = error.message;
        }
        setDropError(message);
        dropzoneProps?.onReject?.(files);
      }}
      {...dropzoneProps}
      maxSize={dropzoneProps?.maxSize ?? 5 * 1024 ** 2}
      accept={
        dropzoneProps?.accept ?? [
          MIME_TYPES.pdf,
          MIME_TYPES.csv,
          MIME_TYPES.xls,
          MIME_TYPES.xlsx,
        ]
      }
      classNames={{
        root: clsx(styles.dropzoneRoot, classNames?.root),
        content: clsx(styles.dropzoneContent, classNames?.content),
      }}
      activateOnClick={false}
      openRef={openRef}
    >
      {/* {uploadIcon && <Box className={styles.iconWrap}>{uploadIcon}</Box>} */}

      <Stack
        spacing={12}
        align="center"
        className={clsx(styles.content, classNames?.content)}
      >
        {localValue ? (
          <Stack spacing={6} justify="center" align="center">
            <h4 className={styles.title}>{localValue.name}</h4>
            <Button small minimal intent={Intent.DANGER} onClick={handleRemove}>
              Remove
            </Button>
          </Stack>
        ) : (
          <Stack spacing={4} align="center">
            {title && <h4 className={styles.title}>{title}</h4>}
            {subtitle && <span className={styles.subtitle}>{subtitle}</span>}
          </Stack>
        )}
        <Button
          intent="none"
          onClick={() => openRef.current?.()}
          style={{ pointerEvents: 'all' }}
          minimal
          className={styles.button}
        >
          {localValue ? 'Replace File' : 'Upload File'}
        </Button>
        <Group className={styles.dropzoneHint}>
          {hintText ?? (
            <>
              <Box>Supported Formats: XLS , CSV, XLSX</Box>
              <Box>Maximum size: 25MB</Box>
            </>
          )}
          {dropError && (
            <Box style={{ color: 'red', fontSize: '12px' }}>{dropError}</Box>
          )}
        </Group>
      </Stack>
    </Dropzone>
  );
}
